import { useNavigate } from "react-router-dom";

import "../../styles/AboutUsHeroSection.css";
import sideImage from '../../assets/Connecting_the_Bridge_EU_Darkhan_Mongolia_Climate_Action_Pathways_1.jpg'

const HomeAboutusSection = () => {
    const navigate = useNavigate();
    return (
        <div className="about-content">
        <div className="about-image">
          <img
            src={sideImage} // Replace with actual image
            alt="Business Meeting"
          />
        </div>
        <div className="about-text">
          <p className="small-title">WHO WE ARE?</p>
          <h2 className="section-title">What is GreenWorks all about?</h2>
          <p className="about-description">
            GreenWorks Consulting is a development consulting firm which provides consulting, training, research, engineering and technology solutions 
            to stakeholders from all parts of the world. We partner and collaborate with national, international, bilateral, multilateral agencies. 
            Moreover, we further work with public, private and social enterprise sectors in all part of the world to mainstream sustainable development 
            at all level. We strive to integrate economic, social, environmental and sustainable development challenges and recognizing their 
            interlinkages in exploring solutions, so as to achieve goals and targets of sustainable development in all its dimensions with an objective 
            to establish... <button 
                onClick={() => navigate("/about")} // Redirect to the About Us page
                style={{
                 background: "linear-gradient(to right, #00aaff, #00aaff)",
                 color: "#fff",
                 border: "none",
                 padding: "0.5rem 1.5rem",
                 borderRadius: "4px",
                 cursor: "pointer",
                 fontSize: "0.9rem",
            }}>Read More</button>
          </p>
        </div>
      </div>
    );
}

export default HomeAboutusSection;